import client from './client';

export default {
  // async currentUser() {
  //   const response = await client.get('current-user/');
  //   return response.data;
  // },

  async updateUserProfile(data) {
    const response = await client.patch('current-user/', data);
    return response.data;
  },

  async patchProfileImage(data) {
    const response = await client.patch('account/profile-image/', data);
    return response.data;
  },

  async updatePassword(data) {
    const response = await client.patch('account/password/change/', data);
    return response.data;
  },

  async logout() {
    const response = await client.post('logout/');
    return response.data;
  },

  async getTimezone() {
    const response = await client.get('time-zones/');
    return response.data;
  },
};
